import {Box, IconButton, Tooltip} from "@mui/material";
import React, {useContext, useEffect, useState} from "react";

import styles from "./sideBarButton.module.scss";

import {IconButtonInterface} from "../sideBar/SideMenuBar"
import {UIStoreContext} from "../../context";
import {observer} from "mobx-react-lite";
import {useNavigate} from "react-router-dom";
import  UsageIcon from "../sideBar/menu_mui_icons/UsageIcon";
import  TrainIcon from "../sideBar/menu_mui_icons/TrainIcon";
import {SvgIcon} from "@mui/material";

interface SidebarButtonInterface {
    icon: IconButtonInterface;
}

const SidebarButton = ({icon}: SidebarButtonInterface) => {
    const uiStore = useContext(UIStoreContext);
    const navigate = useNavigate()


    const onClick = () => {
        uiStore.setMapDrawerOpen(false);
        uiStore.setCurrentPage(icon.text);
        navigate(icon.url);
    }


    return (
        /*<div className={`${window.location.pathname === "/" + icon.url ? "sidebarIconSelected" : ""}`} onClick={onClick}>*/
        <div
            className={(window.location.pathname === "/" + icon.url) ? styles.sideMenuBarButtonSelected : styles.sideMenuBarButton}>
            <Tooltip title={icon.text} arrow placement="right-start"
                     componentsProps={{
                         tooltip: {
                             sx: {
                                 bgcolor: '#607D8B', // Custom background color
                                 color: '#FFFFFF',
                                 forntFamily: "Everett Regular",
                                 fontSize: '11px',    // Custom font size
                                 letterSpacing: '1px',
                                 '& .MuiTooltip-arrow': { // Target the arrow specifically
                                     color: '#607D8B', // Match the arrow color to the tooltip color
                                 },
                             },
                         },
                     }}
            >
                <Box display="inline-block" >
                <icon.icon
                    scolor={window.location.pathname === "/" + icon.url ? "#ed0b4f" : "#78909C"}
                    onClick={ icon.clickFunction? icon.clickFunction:  onClick}
                ></icon.icon>
                </Box>
            </Tooltip>

        </div>
    )
}

export default observer(SidebarButton)